<template>
  <div>
    <v-progress-circular
      class="loader"
      indeterminate
      color="#da4726"
      v-if="buscando"
    ></v-progress-circular>
    <v-card class="ma-5" elevation="0">
      <v-card-title class="mt-6 ml-6">
        <v-row>
          <v-col cols="12" xs="12" md="6" sm="12">
            <v-select
              class="mb-5 pt-0"
              prefix="MÁQUINA: "
              @change="
                maquinaSeleccionada.maquina != '-'
                  ? setMachine(maquinaSeleccionada.maquina)
                  : null
              "
              v-model="maquinaSeleccionada"
              placeholder="Seleccionar máquina..."
              :items="maquinas_select"
              item-value="id_maquina"
              return-object
              color="primary"
            >
              <template slot="selection" slot-scope="data">
                {{ data.item.maquina.toUpperCase() }}
              </template>
              <template slot="item" slot-scope="data">
                {{ data.item.maquina.toUpperCase() }}
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            xs="12"
            md="6"
            v-if="
              maquinaSeleccionada.maquina != 'imf_nave_2' &&
              maquinaSeleccionada.maquina != 'desmoldeo' &&
              maquinaSeleccionada.maquina != '-'
            "
          >
            <v-autocomplete
              class="mb-5 pt-0"
              prefix="PIEZA: "
              v-model="piezaSeleccionada"
              placeholder="Seleccionar pieza..."
              :items="piezas_maquina"
              return-object
              color="primary"
              item-text="name"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="mb-2">
        <!-- seleccionar franja -->
        <v-row>
          <v-col cols="12" md="5">
            <date-picker
              :labelFecha="'Fecha Inicio'"
              :labelHora="'Hora Inicio'"
              :tipo="1"
            ></date-picker>
          </v-col>
          <v-col cols="12" md="5">
            <date-picker
              :labelFecha="'Fecha Fin'"
              :labelHora="'Hora Fin'"
              :tipo="2"
            ></date-picker>
          </v-col>
          <v-col cols="12" md="2" class="d-flex align-self-center">
            <v-btn block @click="buscar()" :disabled="buscando">Buscar</v-btn>
          </v-col>
        </v-row>

        <!-- tabla con ciclos para moldeo y macheria -->
        <v-divider></v-divider>
        <v-card-title class="mb-0 pb-3 mt-5 pl-0"> CICLOS: </v-card-title>
        <v-data-table
          item-key="id_ciclo"
          :headers="headers_con_piezas"
          @click:row="rowClick"
          :items="historicos_con_piezas"
          :items-per-page="5"
          class="elevation-1 mt-0"
          :footer-props="{
            'items-per-page-text': `Ciclos por página`,
          }"
        >
          <template v-slot:[`item.nombre_maquina`]="{ item }">
            {{ item.nombre_maquina.toUpperCase() }}
          </template>
          <template v-slot:[`item.pieza`]="{ item }">
            {{
              item.nombre_maquina != "desmoldeo"
                ? item.pieza.toUpperCase()
                : "-"
            }}
          </template>
          <template v-slot:[`item.fecha_fin`]="{ item }">
            {{
              item.nombre_maquina == "desmoldeo"
                ? "-"
                : item.fecha_fin
                ? item.fecha_fin
                : "NO REGISTRADA"
            }}
          </template>
          <template v-slot:[`item.fecha_inicio`]="{ item }">
            {{ item.nombre_maquina == "desmoldeo" ? "-" : item.fecha_inicio }}
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn @click="showChart(item)"
              ><v-icon> mdi-finance </v-icon></v-btn
            >
          </template>
          <template v-slot:[`item.duracion`]="{ item }">
            {{ duracion(item) }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="mostrar_modal_historico" persistent>
      <multi-variable-line-chart
        :id_maquina="maquinaSeleccionada.id_maquina"
        :title="titulo_historico_ciclo"
        :available_variables="getVariablesAvailable()"
        :id_ciclo="id_ciclo"
        @close="cerrar"
      />
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";

import { mapActions, mapGetters, mapState } from "vuex";

import datePicker from "@/components/datePicker.vue";
import MultiVariableLineChart from "@/utils/MultiVariableLineChart.vue";

export default {
  name: "HistoricoView",

  components: {
    datePicker,
    MultiVariableLineChart,
  },

  data() {
    return {
      selectedRows: [],
      historicos: [],
      buscando: false,
      piezaSeleccionada: null,
      maquinaSeleccionada: { maquina: null, id_maquina: -1 },
      headers_con_piezas: [
        { text: "ID ciclo", align: "center", value: "id_ciclo" },
        { text: "Maquina", align: "center", value: "nombre_maquina" },
        { text: "Pieza", align: "center", value: "pieza" },
        { text: "Fecha Inicio", align: "center", value: "fecha_inicio" },
        { text: "Fecha Fin", align: "center", value: "fecha_fin" },
        { text: "Duracion", align: "center", value: "duracion" },
        { text: "Acciones", align: "center", value: "actions" },
      ],

      //// ciclo a mostrar
      variables_posibles: [],
      mostrar_modal_historico: false,
      titulo_historico_ciclo: "??",
      id_ciclo: null,
    };
  },

  computed: {
    ...mapGetters(["getMachine", "getInicio", "getFin", "getPiezasMaquina"]),
    ...mapState(["maquinas"]),

    historicos_con_piezas() {
      return this.historicos.map((e) => ({
        id_ciclo: e.id_ciclo,
        pieza: e.pieza,
        nombre_maquina: e.nombre_maquina,
        fecha_inicio: e.fecha_inicio
          ? moment.utc(e.fecha_inicio).format("yyyy/MM/DD HH:mm:ss")
          : null,
        fecha_fin: e.fecha_fin
          ? moment.utc(e.fecha_fin).format("yyyy/MM/DD HH:mm:ss")
          : null,
      }));
    },

    piezas_maquina() {
      return [...this.getPiezasMaquina, { name: "-", id_pieza: null }];
    },

    maquinas_select() {
      return [...this.maquinas, { maquina: "-", id_maquina: -1 }];
    },
  },

  methods: {
    ...mapActions(["getHistoricos", "setMachine", "getVariablesEnCiclo"]),
    ...mapActions("utils", ["setInitDateFilter", "setEndDateFilter"]),

    rowClick(_item, row) {
      const rowNo = this.selectedRows.indexOf(row);
      if (rowNo == -1) {
        this.selectedRows.forEach((e) => e.select(false));
        this.selectedRows = [];
        this.selectedRows.push(row);
        row.select(true);
      } else {
        this.selectedRows.splice(rowNo, 1);
        row.select(false);
      }
    },

    async buscar() {
      this.setInitDateFilter(this.getInicio);
      this.setEndDateFilter(this.getFin);
      this.mostrar_modal_historico = false;
      this.buscando = true;
      this.selectedRows.forEach((e) => e.select(false));
      this.selectedRows = [];
      let payload = {
        fecha_inicio: this.getInicio,
        fecha_fin: this.getFin,
        id_maquina: this.maquinaSeleccionada.id_maquina,
        id_pieza: this.piezaSeleccionada.id,
      };
      const res = await this.getHistoricos(payload);
      this.historicos = res.data;

      this.buscando = false;
    },

    showChart(item) {
      this.getVariablesEnCiclo({ id_ciclo: item.id_ciclo }).then((res) => {
        const midata = res.data;
        this.variables_posibles = midata.filter((v) => v.segundos !== null);
        this.titulo_historico_ciclo = `Ciclo: ${item.id_ciclo}`;
        this.id_ciclo = item.id_ciclo;
        this.mostrar_modal_historico = true;
      });
    },

    cerrar() {
      this.mostrar_modal_historico = false;
    },

    duracion(item) {
      if (!item.fecha_fin) return "-";
      const formatoFecha = "YYYY/MM/DD HH:mm:ss";
      const ini = moment(item.fecha_inicio, formatoFecha);
      const fin = moment(item.fecha_fin, formatoFecha);
      const diferenciaEnMilisegundos = Math.abs(fin.diff(ini));
      const horas = Math.floor(diferenciaEnMilisegundos / (1000 * 60 * 60));
      const minutos = Math.floor(
        (diferenciaEnMilisegundos % (1000 * 60 * 60)) / (1000 * 60)
      );
      const segundos = Math.floor(
        (diferenciaEnMilisegundos % (1000 * 60)) / 1000
      );
      return `${horas} h ${minutos} m ${segundos} s`;
    },
    getVariablesAvailable() {
      // const salida = JSON.parse(JSON.stringify(this.maquinaSeleccionada.variables))
      //  return salida.filter(e=>e.para_acumulado==true)

      const salida = this.maquinaSeleccionada?.variables 
    ? JSON.parse(JSON.stringify(this.maquinaSeleccionada.variables)) 
    : [];
   

      return salida.filter(e => e.es_alarma === false);
    }
  }, //fin de los métodos

  mounted() {
    this.piezaSeleccionada =
      this.piezas_maquina[this.piezas_maquina.length - 1];
    this.maquinaSeleccionada = this.getMachine;
  },

  watch: {
  
    getMachine() {
      this.piezaSeleccionada =
        this.piezas_maquina[this.piezas_maquina.length - 1];
      if (this.maquinaSeleccionada != this.getMachine) {
        this.maquinaSeleccionada = this.getMachine;
      }
    },
  },
};
</script>

<style>
.overflow-x-auto {
  overflow-x: auto;
}
tr.v-data-table__selected {
  background: #ff2f0067 !important;
}
.loader {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
